module.exports = __webpack_public_path__ + "media/images/top/img_pickup_konpira-99bd4a2f8731c58744ebc277992e296d.webp";